// @flow

import * as React from 'react';

export type Props = {|
  offsetStart: number,
  offsetEnd: number,
  total: number
|};

export default function SearchHits(props: Props) {
  return (
    <div
      className="m-search-hits"
      dangerouslySetInnerHTML={{
        __html: I18n.t('search.search_results.results_count', {
          offsetStart: props.offsetStart,
          offsetEnd: props.offsetEnd,
          total: props.total
        })
      }}
    />
  );
}
